import React, { useState } from 'react';
import { Redirect } from "react-router-dom";

const NotFound = () => {
  const [redirect, setRedirect] = useState(false);
  setTimeout(() => setRedirect(true), 1000);
  return redirect ? <Redirect to={'/'}/>
    : <div style={{textAlign: 'center', padding: '50vh'}}>
      NOT FOUND<br/>redirecting...
    </div>;
};

export default NotFound;